export default __webpack_public_path__ + "497f5dea60b4d139fcca1af235890c4d.png";